// src/utils/isPrerendering.js

export function isPrerendering() {
  if (typeof window === "undefined") return true;
  if (typeof navigator === "undefined") return true;

  const userAgent = String(navigator.userAgent || "").toLowerCase();

  return (
    userAgent.includes("reactsnap") ||
    userAgent.includes("react-snap") ||
    window.__REACT_SNAP__ === true
  );
}